<template>
    <AnimationWrapper>
        <template #animationContent>
            <a
                :href="resolvedUrl"
                target="_blank"
                rel="nofollow noopener"
                :style="itemStyle"
                :class="['social-icon-item', { fill: isFill }]"
            >
                <i :class="['fa', `fa-${cleanType}`]"></i>
            </a>
        </template>
    </AnimationWrapper>
</template>

<script>
import AnimationWrapper from "@/scripts/common/components/AnimationWrapper.vue";
import {
    UiItemCornerRadiusDefault,
    UiItemFillTypeEnum,
    UiItemStrokeWeightDefault,
} from "@/scripts/common/enums.js";

export default {
    name: "SocialIcon",
    components: { AnimationWrapper },
    props: {
        link: {
            type: Object,
            default: null,
        },
        fillType: {
            type: String,
            default: UiItemFillTypeEnum.OUTLINE,
        },
        cornerRadius: {
            type: Number,
            default: UiItemCornerRadiusDefault,
        },
        outlineWeight: {
            type: Number,
            default: UiItemStrokeWeightDefault,
        },
    },
    computed: {
        isFill() {
            return this.fillType === UiItemFillTypeEnum.FILL;
        },
        cleanType() {
            const raw = (this.link?.type || "").toString().toLowerCase();
            return raw === "x" ? "x-twitter" : raw;
        },
        resolvedUrl() {
            return this.link?.url || "#";
        },
        itemStyle() {
            const style = {
                borderRadius: `${this.cornerRadius}px`,
            };

            if (!this.isFill) {
                style["--social-icon-outline-weight"] = `${this.outlineWeight}px`;
            }

            return style;
        },
    },
};
</script>

<style scoped lang="scss">
.social-icon-item {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 46px;
    min-height: 46px;
    aspect-ratio: 1/1;
    font-size: 16px;
    text-decoration: none;
    transition: color 150ms ease, background-color 150ms ease, box-shadow 200ms ease;
    background-color: transparent;

    color: var(--social-icon-text-color);

    &.fill {
        background-color: var(--social-icon-fill-color);
    }

    &:not(.fill) {
        box-shadow: inset 0 0 0 var(--social-icon-outline-weight, 1px)
        var(--social-icon-outline-color, var(--border-color));
    }

    &:hover {
        &:not(.fill) {
            color: var(--social-icon-text-color-hover);
            box-shadow: inset 0 0 0 var(--social-icon-outline-weight, 1px)
                var(--social-icon-outline-color-hover, var(--social-icon-text-color-hover));
        }

        &.fill {
            color: var(--social-icon-text-color-hover);
            background-color: var(--social-icon-fill-color-hover);
        }
    }
}

</style>
